import React, { FC } from 'react';
import Typography from 'app/components/Typography';
import { TYPOGRAPHY } from 'app/components/Typography/models.d';
import { FullWidthProps } from './models.d';
import Container from 'app/layouts/layout/Container';
import './FullWidth.scss';

const Banner: FC<FullWidthProps> = ({
  bannerImg,
  img_alt,
  bannerTitle,
  titleColor,
}) => {
  const renderBanner = bannerImg ? (
    <div className="banner-full-width">
      <img
        src={bannerImg}
        alt={img_alt ?? ''}
        className="banner-full-width__img"
      />
      {bannerTitle && (
        <Container>
          <Typography
            variant={TYPOGRAPHY.VARIANT.H2}
            inlineStyle={{ color: titleColor ?? '#fff' }}
            className="banner-full-width__title"
          >
            {bannerTitle}
          </Typography>
        </Container>
      )}
    </div>
  ) : null;

  return renderBanner;
};

export default Banner;
